import { takeEvery, put, select, call } from "redux-saga/effects";
import * as actionTypes from "constants/actionTypes";
import { createGoalInFirebase } from "sagas/account/goals";
import * as ruleActions from "actions/account/rules";
import { trackEvent } from "actions/events";
import { updateGoalInStore } from "actions/goals";
import apiActions from "actions/api";
import { selectUserId } from "reducers/user";

/**
 * Creates a new goal from the specified branch of the current
 * conditions tree and saves in Firebase with a newly generated ID.
 *
 * @param action
 */

export function* createGoal(action) {
  const { name, conditions, stepId } = action.payload;

  const now = new Date().getTime();

  const userId = yield select(selectUserId);

  const goal = {
    conditions,
    updatedAt: now,
    updatedBy: userId,
    goalFormatVersion: 2,
    defaultGoal: false,
    createdBy: userId,
    createdAt: now,
    enabledTs: [now],
    goalVersion: 1,
    name
  };

  const goalId = yield call(createGoalInFirebase, goal);

  if (stepId) {
    yield put(ruleActions.setGoal(stepId, goalId));
  }

  yield put(apiActions.hitPublishHook());

  yield put(
    trackEvent("Created a goal", {
      name,
      goal_id: goalId
    })
  );

  /* global GOAL_CREATED_MODAL_ID */
  if (window.Appcues && GOAL_CREATED_MODAL_ID) {
    window.setTimeout(() => {
      window.Appcues.show(GOAL_CREATED_MODAL_ID);
    }, 1000);
  }
}

function* updateGoalAndFlushGoal(action) {
  const { goalId, changes } = action.payload;
  const { disabled } = changes;

  const now = new Date().getTime();
  const userId = yield select(selectUserId);

  yield put(
    updateGoalInStore(goalId, { ...changes, updatedAt: now, updatedBy: userId })
  );

  yield put({
    type: actionTypes.FLUSH_GOAL_TO_FIREBASE,
    payload: {
      goalId
    }
  });

  yield put(apiActions.hitPublishHook());

  if (disabled) {
    yield put(
      trackEvent("Disabled a goal", {
        goal_id: goalId
      })
    );
  } else {
    yield put(
      trackEvent("Enabled a goal", {
        goal_id: goalId
      })
    );
  }
}

function* deleteGoalAndFlushGoal(action) {
  const { goalId } = action.payload;

  yield put({
    type: actionTypes.DELETE_GOAL_IN_STORE,
    payload: {
      goalId
    }
  });

  yield put({
    type: actionTypes.FLUSH_GOAL_TO_FIREBASE,
    payload: {
      goalId
    }
  });

  yield put(apiActions.hitPublishHook());

  yield put(
    trackEvent("Deleted a Goal", {
      goal_id: goalId
    })
  );
}

export function* goals() {
  yield takeEvery(actionTypes.CREATE_GOAL, createGoal);
  yield takeEvery(
    actionTypes.UPDATE_GOAL_AND_FLUSH_GOAL,
    updateGoalAndFlushGoal
  );
  yield takeEvery(
    actionTypes.DELETE_GOAL_AND_FLUSH_GOAL,
    deleteGoalAndFlushGoal
  );
}

export default goals;
